import { ELIGIBILITY_CALCULATOR_ENDPOINTS, LEADS_ENDPOINTS } from "../constants/apiEndpoints";
import { getWrapper, getWrapperWeb, patchWrapper, postWrapperWeb, deleteWrapper } from "../utils/Wrapper";

export const getLeads = (leadType, pageable) => {
  const params = new URLSearchParams();
  params.append("leadType", leadType);
  if (pageable.page !== "") params.append("page", pageable.page);
  if (pageable.size) params.append("size", pageable.size);
  if (pageable.startDate) params.append("startDate", pageable.startDate);
  if (pageable.endDate) params.append("endDate", pageable.endDate);
  if (pageable.searchQuery) params.append("searchQuery", pageable.searchQuery);
  if (pageable.sortBy) params.append("sortBy", pageable.sortBy);
  if (pageable.order) params.append("order", pageable.order);
  
  const url = `${LEADS_ENDPOINTS.GET_LEADS}?${params.toString()}`;
  return getWrapper(url);
};

export const getLeadDetails = (leadId, leadType) => {
  const url = `${LEADS_ENDPOINTS.GET_LEAD_DETAILS}/${leadId}?leadType=${leadType}`;
  return getWrapperWeb(url);
};

export const updateLeadStatus = (leadId, leadStatus) => {
  const url = `${LEADS_ENDPOINTS.UPDATE_LEAD_STATUS}?id=${leadId}&status=${leadStatus}`;
  return patchWrapper(url);
};

export const getLoanRequirements = () => {
  const url = `${ELIGIBILITY_CALCULATOR_ENDPOINTS.GET_REQUIREMENTS}`;
  return getWrapperWeb(url);
};

export const createLead = (data) => {
  const url = `${ELIGIBILITY_CALCULATOR_ENDPOINTS.CREATE_LEAD}`;
  return postWrapperWeb(url,data);
};

export const deleteLead = (leadId) => {
  const url = `${LEADS_ENDPOINTS.DELETE_LEAD}?id=${leadId}`;
  return deleteWrapper(url);
};
